import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid2, IconButton, InputBase, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
import { FaCircleChevronDown, FaIndianRupeeSign, FaPlus, FaRupeeSign } from "react-icons/fa6";
import { styled, useTheme } from '@mui/material/styles';
import TableComponent from "components/grid";
import AddIssue from "./AddIssue";
import { useDispatch } from 'store';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import { useGetAllIssueQuery } from "store/slices/apis/packageSlice";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { HighlightOffTwoTone } from "@mui/icons-material";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { useParams } from "react-router-dom";
import EditIssue from "./EditIssue";
import { useDeleteKeyIssueMutation, useGetPendingIssueQuery } from "store/slices/apis/keyIssueSlice";
// import DatePicker from "react-datepicker";
import moment from "moment";
import { MdOutlineFilterAlt } from "react-icons/md";
import ApproveIssueComponent from "components/action/ApproveIssueComponent";
import RejectIssueComponent from "components/action/RejectIssueComponent";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"


const columns = [
    {
        name: 'Issue ID',
        field: 'issueNumber',
        renderer(params) {
            return (
                <Stack direction="row" spacing={1}>
                    {params?.issueNumber &&
                        <Chip label={params?.issueNumber} size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px',
                                fontWeight: 600
                            }
                        }} />
                    }
                </Stack>
            );
        }
    },
    {
        name: 'Contractor',
        field: 'contractor',
    },
    {
        name: 'Category',
        field: 'package',
    },
    {
        name: 'Issue description',
        field: 'issueDescription',
    },
    {
        name: 'Reported date',
        field: 'reportedDate',
        renderer(params) {
            return (
                <>
                    {params?.reportedDate
                        ? moment(params.reportedDate).format("DD/MM/YY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Workflow status',
        field: 'workflowStatus',
    },
    {
        name: 'Current status',
        field: 'currentStatus',
    },
    {
        name: "Created Date",
        field: "createdDate",
        renderer(params) {
            return (
                <>
                    {params?.createdDate
                        ? moment(params.createdDate).format("DD/MM/YY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Actions required by',
        field: 'actionRequiredBy',
    },
    {
        name: 'Actions required by email',
        field: 'actionRequiredByEmail',
    },
    {
        name: 'Time impact (Days)',
        field: 'timeImpact',
    },
    {
        name: 'Cost impact',
        field: 'costImpact',
        renderer(params) {
            return (

                <Stack direction="row" spacing={1}>
                    {params?.costImpact ?
                        <Chip icon={<FaIndianRupeeSign />} label={params?.costImpact} sx={{
                            backgroundColor: '#3E756D',
                            color: '#fff',
                            fontSize: '12px',
                            height: '18px',
                            '& .MuiChip-icon': {
                                color: '#fff'
                            },
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px'
                            }
                        }} />
                        : <Chip label="N/A" size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px'
                            }
                        }} />
                    }

                </Stack>
            );
        }
    },
    {
        name: 'Action',
        field: 'action',
        option: {
            view: false,
            delete: false,
            edit: false,
            acceptReject: true
        }
    },
];

const currentStatuses = [
    { label: "Open", year: 1994 },
    { label: "Close", year: 1972 }
];

const PendingApproval = () => {
    const theme = useTheme();
    const [showAddIssue, setShowAddIssue] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [deleteItem, setDeleteItem] = useState(null);
    const [isDeleteModal, setDeleteModal] = useState(false);

    const [isIssueApprove, setIsIssueApprove] = useState(false);
    const [isIssueReject, setIsIssueReject] = useState(false);
    const [rowData, setRowData] = useState(null);

    // filter data
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [currentStatus, setCurrentStatus] = useState('');

    const [filters, setFilters] = useState({
        fromDate: '',
        toDate: '',
        currentStatus: '',
    });

    // Edit model state
    const [isEditIssueModal, setEditIssueModal] = useState(false);
    const [issueData, setEditIssueData] = useState(null);

    // View model state
    const [isViewIssueModal, setIsViewIssueModal] = useState(false);

    const { projectId } = useParams();
    const { data: pendingIssues, isLoading } = useGetPendingIssueQuery({
        projectId,
        page: pageNumber,
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        currentStatus: filters?.currentStatus,
    });
    const [issueDeleteFn, issueDeleteRes] = useDeleteKeyIssueMutation();
    // console.log(allIssues?.data?.issues);

    const dispatch = useDispatch();

    const handleAddIssue = () => {
        setShowAddIssue(!showAddIssue);
    }

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    const handleActionEdit = (row) => {
        setEditIssueModal(!isEditIssueModal)
        if (!issueData) {
            setEditIssueData(row);
        } else {
            setEditIssueData(null);
        }

    }


    const handleActionView = (row) => {
        setIsViewIssueModal(!isViewIssueModal)
        if (!issueData) {
            setEditIssueData(row);
        } else {
            setEditIssueData(null);
        }

    }

    const handleActionDelete = (row) => {
        setDeleteItem(row);
        setDeleteModal(true);
    }

    const handleConfirmationDelete = () => {
        issueDeleteFn(deleteItem?.id)
    }

    useEffect(() => {
        if (issueDeleteRes?.isSuccess) {
            if (issueDeleteRes?.data?.status == 'Success') {
                openNotification(issueDeleteRes?.data?.message, 'success')
            } else {
                openNotification(issueDeleteRes?.data?.message, 'error')
            }
            handleCloseDelete();
        }
    }, [issueDeleteRes?.isSuccess]);

    const handleCloseDelete = () => {
        setDeleteItem(null);
        setDeleteModal(false);
    }

    const handleActionAcceptIssue = (row) => {
        setIsIssueApprove((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const handleActionRejectIssue = (row) => {

        setIsIssueReject((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const confirmationDeleteDialog = () => (
        <Dialog
            open={isDeleteModal}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle sx={{ fontWeight: 500, fontSize: '20px', color: '#252525', paddingBottom: 0 }} id="draggable-dialog-title">
                Delete
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleCloseDelete}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                {/* <IoMdClose style={{ fontSize: '20px' }} /> */}
                <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
            </IconButton>
            <DialogContent>
                <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747' }}>
                    Are you sure you want to Delete this issue? This action is permanent.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleCloseDelete} sx={{
                    color: '#415385',
                    fontSize: '16px',
                    fontWeight: '500',
                    textTransform: 'none',
                    border: '1px solid #415385'
                }}>Cancel</Button>
                <Button onClick={handleConfirmationDelete} loading={issueDeleteRes?.isLoading} variant="contained" sx={{
                    backgroundColor: '#C52A1A',
                    color: '#fff',
                    fontSize: '16px',
                    fontWeight: '500',
                    textTransform: 'none'
                }}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <>
            {confirmationDeleteDialog()}
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Stack direction="row" spacing={2} sx={{ flexGrow: 1, alignItems: 'center' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={['DatePicker', 'DatePicker']}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slotProps={{
                                            textField: {
                                                sx: { minWidth: 150 },
                                                size: 'small'
                                            }
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker', 'DatePicker']}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setToDate(newValue)}
                                        slotProps={{
                                            textField: {
                                                sx: { minWidth: 150 },
                                                size: 'small'
                                            }
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Autocomplete
                                options={currentStatuses}
                                getOptionLabel={(option) => option?.label}
                                onChange={(_, newValue) => setCurrentStatus(newValue ? newValue?.label : '')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Current Status"
                                        name="currentStatus"
                                        // slotProps={{ inputLabel: { shrink: true } }}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& .MuiFilledInput-root': {
                                                backgroundColor: '#fff'
                                            }
                                        }}
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: "13px" },
                                }}
                                sx={{ width: "23%", marginTop: '7px !important' }} // Adjust width
                            />
                            <Button
                                loading={isLoading}
                                onClick={() => {

                                    setFilters({
                                        fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
                                        toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : '',
                                        currentStatus,
                                    });
                                    // refetch();
                                }}
                                size="medium"
                                startIcon={
                                    // <IoMdSearch />
                                    <SearchIcon style={{ height: "20px", width: "20px", fill:`${theme?.customSettings?.themeColor}` }} />
                                }
                                variant='outlined' sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: 'none',
                                    textTransform: 'inherit'
                                }}>
                                Search
                            </Button>
                        </Stack>
                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns}
                        data={pendingIssues?.data?.issues}
                        actionDelete={handleActionDelete}
                        actionEdit={handleActionEdit}
                        actionView={handleActionView}
                        actionAccept={handleActionAcceptIssue}
                        actionReject={handleActionRejectIssue}
                        isLoading={isLoading}
                    />
                    {!isLoading && (
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <PaginationComponent
                                pageNumber={pendingIssues?.data?.page || 1}
                                totalPages={Math.ceil(pendingIssues?.data?.totalRecords / pendingIssues?.data?.pageSize) || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>

            <ApproveIssueComponent open={isIssueApprove} cancel={handleActionAcceptIssue} rowData={rowData} type={'issue'} openNotification={openNotification} />
            <RejectIssueComponent open={isIssueReject} cancel={handleActionRejectIssue} rowData={rowData} type={'issue'} openNotification={openNotification} />
        </>
    );
};

export default PendingApproval;